<template>
  <div class="login-page">
    <div class="login-page__content" :style="{ backgroundImage: bg }">
      <div v-show="isLoading" class="login-page__preloader">
        <spinner :animation-duration="1000" :size="60" :color="'#2E79EF'" />
      </div>
      <form @submit.prevent="login" class="login-form" autocomplete="off">
        <h1 class="login-form__heading">{{ $t("entrance") }}</h1>
        <div class="login-form__content">
          <div class="login-form__input-container">
            <label class="login-form__label">{{ $t("user name") }}</label>
            <input
              v-model="userName"
              type="text"
              placeholder="Логин"
              class="login-form__input"
            />
          </div>
          <div class="login-form__input-container">
            <label class="login-form__label">{{ $t("password") }}</label>
            <input
              v-model="userPassword"
              type="password"
              placeholder="Пароль"
              class="login-form__input"
            />
          </div>
          <vue-recaptcha
            v-if="this.$store.state.user.isCaptchaRequired"
            class="login__captcha"
            ref="recaptcha"
            :sitekey="captchaSiteKey"
            @verify="registerCaptchaToken"
            @expired="onCaptchaExpired"
          />
          <div class="login-form__submit">
            <button type="submit" class="login-form__button button filled">
              {{ $t("login") }}
            </button>
            <router-link
              :to="{ name: 'auth-recovery-by-email' }"
              class="login-form__recovery"
              >{{ $t("password recovery") }}</router-link
            >
          </div>
        </div>
      </form>
      <select
        id="storageSelect"
        onclick="getActiveTokensCall();"
        class="hidden custom-select form-control"
      >
        <option value="PKCS12">ЭЦП</option>
      </select>
      <button
        v-on:click="signToLogin()"
        class="login-form__ecp-button button filled"
      >
        <span v-if="!isEcpLoading">{{ $t("eds login") }}</span>
        <span v-if="isEcpLoading">
          <spinner :animation-duration="1000" :size="17" :color="'#ffffff'" />
        </span>
      </button>
      <ecp-modal
        :class="{ hidden: !isEcpModalVisible }"
        @toggleModal="toggleEcpModal"
      />
      <router-link :to="{ name: 'register-pe' }" class="login-form__register"
        >Регистрация</router-link
      >
      <p class="login-form__error" :class="{ invisible: !error }">
        Неправильно введен пароль или логин
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { HalfCircleSpinner } from "epic-spinners";
import EcpModal from "@/components/login/EcpModal.vue";
import Vue from "vue";
import VueRecaptcha from "vue-recaptcha";

export default {
  components: {
    spinner: HalfCircleSpinner,
    "ecp-modal": EcpModal,
    "vue-recaptcha": VueRecaptcha
  },
  data() {
    return {
      userName: "",
      userPassword: "",
      isLoading: false,
      error: false,
      isEcpModalVisible: false,
      isEcpLoading: false,
      captchaSiteKey: "6LdXf8EUAAAAAJ_rvu7asawAuTeMZ2Zbm0iCNvGm",
      captchaToken: "",
      isCaptchaNotVerified: false,
      sign: ""
    };
  },
  created() {
    if (this.$store.state.user.loggedIn) {
      this.$router.push({ path: "/" });
    }
  },
  computed: {
    bg() {
      return "@/assets/images/bg-auth.jpg";
    }
  },
  methods: {
    ...mapActions(["userLogin"]),
    signToLogin() {
      this.isEcpLoading = true;
      if (!Vue.prototype.$isLayerConnected()) {
        Vue.prototype.$reconnectLayer();

        setTimeout(() => {
          if (!Vue.prototype.$isLayerConnected()) {
            this.isEcpLoading = false;
            return this.$toasted.error(
              "Программа NCALayer не запущена. Запустите ее и повторите попытку."
            );
          }

          this.isEcpLoading = false;
          Vue.prototype.$signXmlAuthCall(this.getXml(), this, "sign");
        }, 2000);
      } else {
        Vue.prototype.$signXmlAuthCall(this.getXml(), this, "sign");
        this.isEcpLoading = false;
      }
    },
    login() {
      this.isLoading = true;
      this.userLogin({
        userName: this.userName,
        userPassword: this.userPassword,
        captchaToken: this.captchaToken
      })
        .then(() => {
          this.isLoading = false;
          // Если пользователь не завершил регистрацию, перенаправляем его на соответствующую страницу
          this.$router.push({ path: "/finance" });
        })
        .catch(() => {
          this.isLoading = false;
          this.$toasted.error("Произошла ошибка");
          this.error = true;
        });
    },
    handleInput() {
      // Если пользователь изменяет данные, скрываем сообщение об ошибке
      this.error = false;
    },
    // Функция вызывается, когда пользователь успешно проходит капчу. Добавляем токен капчи в состояние компонента
    registerCaptchaToken(captchaToken) {
      // Убираем сообщение о непройденной капче
      this.isCaptchaNotVerified = false;
      // Сохраняем токен в состоянии
      this.captchaToken = captchaToken;
    },
    // Функция вызывается, когда срок годности капчи истекает
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
      // При истечении капчи, очищаем ее токен в состоянии
      this.captchaToken = "";
    },
    loginByEds() {
      this.isLoading = true;
      this.userLogin({
        userName: "",
        userPassword: "",
        sign: this.sign,
        byEds: true
      })
        .then(() => {
          this.$router.push({ path: "/finance" });
        })
        .catch(() => {
          this.error = true;
          this.isLoading = false;
        });
    },
    toggleEcpModal() {
      this.isEcpModalVisible = !this.isEcpModalVisible;
    },
    getXml() {
      return (
        '<?xml version="1.0" encoding="UTF-8"?><login><authTime>' +
        new Date().getTime() +
        "</authTime></login>"
      );
    }
  }
};
</script>

<style scoped>
.login-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #ffffff;
}

.login-page__top-bar {
  width: 100%;
  box-sizing: border-box;
}

.login-page__content {
  background-image: url("../../assets/images/bg-auth.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 90vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #222c44;
  box-sizing: border-box;
}

.login-page__preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  background-color: rgba(47, 58, 87, 0.5);
}

.login-form {
  width: 360px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login-form__heading {
  font-weight: normal;
  font-size: 36px;
}

.login-form__content {
  margin-top: 33px;
  display: flex;
  flex-direction: column;
}

.login-form__input-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.login-form__input-container:not(:last-child) {
  margin-bottom: 15px;
}

.login-form__label {
  font-size: 15px;
}

.login-form__input {
  width: 70%;
  padding: 10px;
  font-size: 15px;
  outline: none;
  background-color: #ffffff;
  border: 1px solid #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.login-form__submit {
  margin-top: 20px;
  width: 70%;
  align-self: flex-end;
  display: flex;
  align-items: center;
}

.login-form__recovery {
  margin-left: 18px;
  font-size: 13px;
  color: #acb5c5;
  text-decoration: none;
}

.login-form__button {
  padding: 15px 30px;
}

.login-form__error {
  margin-top: 20px;
  color: #ef4748;
}

.login-form__signup {
  margin-top: 10px;
  color: #ccc;
  font-weight: 300;
  text-decoration: none;
}

.invisible {
  visibility: hidden;
}

.login-form__ecp-button {
  margin-top: 20px;
  width: 360px;
  padding: 15px 0;
  font-size: 15px;
}

.login-form__register {
  margin-top: 20px;
  text-decoration: none;
  font-size: 14px;
  color: #acb5c5;
}
</style>
